import { useSearchParams } from "react-router-dom";

import { readPage, withParams } from "@/lib/url-params";

export const PAGE_SIZES = [10, 20, 50, 100] as const;
export const DEFAULT_PAGE_SIZE = 20;

/** Sahifa hajmi — faqat ro'yxatdagisi: backend 100 dan kattasini rad etadi. */
export function readLimit(params: URLSearchParams): number {
  const limit = Number(params.get("limit"));
  return (PAGE_SIZES as readonly number[]).includes(limit) ? limit : DEFAULT_PAGE_SIZE;
}

/** Sahifa va hajm manzilda: havola ulashilganda ham o'sha ko'rinish ochiladi. */
export function useUrlPagination() {
  const [params, setParams] = useSearchParams();
  const page = readPage(params);
  const limit = readLimit(params);

  return {
    page,
    limit,
    setPage: (next: number) => setParams(prev => withParams(prev, { page: next })),
    // Hajm o'zgarsa birinchi sahifaga: 5-sahifa yangi hajmda umuman bo'lmasligi mumkin.
    setLimit: (next: number) =>
      setParams(prev =>
        withParams(prev, { limit: next === DEFAULT_PAGE_SIZE ? undefined : next, page: 1 }),
      ),
  };
}
